module.exports = __webpack_public_path__ + "static/img/yxDriver.6e741b04.png";